// extracted by mini-css-extract-plugin
export default {"home":"Home_home__obAgv","container":"Home_container__hJt3g","input":"Home_input__B6xCQ","heading":"Home_heading__GJSJJ","label":"Home_label__fvy5t","submit":"Home_submit__Er+Oi"};